import Spinners from "components/Shared/Spinners"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { Container, Row } from "reactstrap"
import {
  getPrivacyPolicy,
  getTermsConditions,
} from "store/actions/globalSettingAction"

const AppTermsConditions = () => {
  const dispatch = useDispatch()
  const { lang } = useParams()

  const { loading, termsConditions } = useSelector(
    state => state.GlobalSettings
  )

  useEffect(() => {
    const fetchTermsConditions = () => {
      dispatch(getTermsConditions())
    }
    fetchTermsConditions()
  }, [lang])

  const content =
    lang === "sa"
      ? termsConditions?.descriptionAr
      : termsConditions?.description

  if (loading) return <Spinners />

  return (
    <React.Fragment>
      <div className="frutiger_font app_content">
        <Container>
          <Row className="my-3" dir={lang === "sa" ? "rtl" : "ltr"}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AppTermsConditions
